module.exports = __webpack_public_path__ + "static/media/35-iveco-mercedes.f3ed5955.jpg";